import React, { useContext, useEffect, useState } from "react";
import { Button, Dialog, Icon } from "@app/components";
import { SuccessContainer, ProfileSuccessText } from "./success-components";
import { SuccessText } from "@app/modules/signUp/sign-up.component";
import { AuthContext } from "@app/providers";

type Props = { onClose: (e: any) => void; addChild: (e: any) => void, message: string; subtitle?: string; buttonMessage?: string };

export default function Pill({ onClose, addChild, message, subtitle = '', buttonMessage = "Okay!" }: Props) {
  const { userInfo, setUserInfo }: any = useContext(AuthContext);
  const [userType, showUserType] = useState(userInfo && userInfo.userType)
  const [userDetails, updateUserDetails] = useState<any>();
  const [userData, SetUserData] = useState<any>();
  useEffect(() => {
    let paymentSource: any = localStorage.getItem("paymentSource");
    let key = paymentSource === "signUp" ? "paymentUser" : "userData";
    let data: any = localStorage.getItem(`${key}`);
    let type: any = JSON.parse(data)
    SetUserData(type.userType)
    if (data) {
      data = JSON.parse(data);
      if (data["userJson"]) {
        data = data.userJson;
      }
      // SetUserData(data);
    }
  }, [userInfo])

  return (
    <Dialog noTitle={true} onClose={onClose}>
      <SuccessContainer>
        <Icon name="signsuccess" />
        <ProfileSuccessText className="success-color">{message}</ProfileSuccessText>
        {subtitle &&
          <SuccessText>
            Authentication verified successfully.
          {userData === "parent" ?
              <> <br /> Click here to
           <button
                  className="anchor-tag"
                  type="button"
                  onClick={addChild}
                >
                  Add Child(ren)
           {/* {subtitle} */}
                </button>
           to your account
           </>
              : ''}
          </SuccessText>
        }
        {buttonMessage &&
          <Button
            variant="newsecondary"
            type="button"
            onClick={onClose}
          >
            {buttonMessage}
          </Button>
        }
      </SuccessContainer>
    </Dialog>
  );
}
